import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import UIDateFormater, {
  DateType,
} from '../../containers/UIhelper/UIDateFormater';

import '../AlertsBurstTabs/alertsTabs.scss';

const MobileDeviceHistory = (props, context) => {
  const { history, actionOptions, stateOptions, timeZone, onAddComment } = props;
  const [comment, setComment] = React.useState('');
  const editMode = useSelector((state) => state.leaksList.user?.editMode);

  const labelFor = (options, value) => {
    if (!options || value == null) {
      return '';
    }
    const found = options.find((opt) => opt.value === value);
    return found ? found.label || found.DisplayName || '' : '';
  };

  const handleSend = () => {
    const trimmed = comment.trim();
    if (trimmed.length === 0) {
      return;
    }
    const result = onAddComment(trimmed);
    // Only clear the input once the comment is actually saved, so a failed
    // request doesn't silently lose the user's text.
    if (result && typeof result.then === 'function') {
      result.then((json) => {
        if (json && json.status) {
          setComment('');
        }
      });
    } else {
      setComment('');
    }
  };

  return (
    <div>
      <div
        className='comment-area'
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '8px',
          // Float the comment box so it stays visible while the history scrolls.
          // Negative margins cancel the surrounding Box padding (16px) so it spans
          // the full width and pins flush to the top of the scrollable panel.
          position: 'sticky',
          top: 0,
          zIndex: 2,
          margin: '-16px -16px 10px',
          padding: '12px 16px',
          background: '#f5f9fa',
          borderBottom: '1px solid #d0e8ef',
        }}
      >
        <textarea
          className='form-control'
          placeholder={context.t('add_comment')}
          value={comment}
          maxLength={225}
          rows={2}
          disabled={!editMode}
          onChange={(e) => setComment(e.target.value)}
          style={{ flex: 1, resize: 'vertical' }}
        />
        <button
          className='btn btn-info'
          onClick={handleSend}
          disabled={!editMode}
          style={{ whiteSpace: 'nowrap' }}
        >
          {context.t('add_comment')}
        </button>
      </div>

      <ul
        className='history-container'
        // Let the surrounding tab body scroll the full list instead of the
        // shared 37vh clip, which cut rows off below the panel.
        style={{ maxHeight: 'none', overflow: 'visible', margin: 0 }}
      >
        {(history || []).map((item, index) => {
          const actionLabel = labelFor(actionOptions, item.action_code);
          const stateLabel = labelFor(stateOptions, item.device_state);
          const time = UIDateFormater(
            item.logging_date,
            DateType.DATE_AND_TIME_WITH_SECONDS,
            timeZone,
            props.projectTimezone
          );
          return (
            <li key={index} className='burst-history-item'>
              <strong>{item.user_name}</strong>
              <span>
                {' '}
                {actionLabel}
                {stateLabel && <strong> {stateLabel}</strong>}
                {item.comment && <i> {item.comment}</i>}
              </span>
              <span className='burst-history-time'>{time}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

MobileDeviceHistory.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default MobileDeviceHistory;
